import actionTypes from '../actionTypes';

export const getWorkOwnerships = (workId) => ({
  type: actionTypes.WORK_OWNERSHIPS_GET_REQUEST,
  workId,
});

export const setWorkOwnerships = (workOwnerships) => ({
  type: actionTypes.WORK_OWNERSHIPS_SET,
  workOwnerships,
});

export const getWorkOwnership = (workId, id) => ({
  type: actionTypes.WORK_OWNERSHIP_GET_REQUEST,
  workId,
  id,
});

export const createWorkOwnership = (workOwnership) => ({
  type: actionTypes.WORK_OWNERSHIP_CREATE_REQUEST,
  workOwnership,
});

export const updateWorkOwnership = (workOwnership) => ({
  type: actionTypes.WORK_OWNERSHIP_UPDATE_REQUEST,
  workOwnership,
});

export const deleteWorkOwnership = (workOwnership) => ({
  type: actionTypes.WORK_OWNERSHIP_DELETE_REQUEST,
  workOwnership,
});



// WEBPACK FOOTER //
// src/redux/actions/workOwnerships.js